<!--
  ~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
  -->

<ng-template cdkConnectedOverlay
             cdkConnectedOverlayLockPosition
             cdkConnectedOverlayFlexibleDimensions
             [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
             cdkConnectedOverlayPush="{{overlayPush}}"
             [cdkConnectedOverlayPanelClass]="panelClass"
             [cdkConnectedOverlayOpen]="isOpen"
             [cdkConnectedOverlayOrigin]="triggerRef"
             [cdkConnectedOverlayMinWidth]="elementRect?.width"
             [cdkConnectedOverlayPositions]="positions"
             (detach)="close()">
  <div class="dropdown-area" [class.scroll-y]="hasOverflowY" cdkTrapFocus cdkTrapFocusAutoCapture="true" [attr.id]="dropdownId">
    <ng-content></ng-content>
  </div>
</ng-template>
